import { render } from "./Textinput.vue?vue&type=template&id=0395e816"
import script from "./Textinput.vue?vue&type=script&lang=js"
export * from "./Textinput.vue?vue&type=script&lang=js"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__